import { ConnectedPosition } from '@angular/cdk/overlay';
import { CdkMenuModule } from '@angular/cdk/menu';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { LANG_OPTIONS, LanguageService } from '@lyricstream/shared';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Sélecteur de langue du site : bouton + menu Angular CDK (`cdkMenu`), ancré au bouton. Le CDK fournit le positionnement
 * (au-dessus du bouton, sinon en dessous), la navigation au clavier (flèches, Entrée, Échap), le retour du focus au bouton
 * et la fermeture au clic extérieur.
 */
@Component({
  selector: 'app-lang-picker',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CdkMenuModule, TranslateModule],
  templateUrl: './lang-picker.component.html',
  styleUrl: './lang-picker.component.scss',
})
export class LangPickerComponent {
  protected readonly langService = inject(LanguageService);
  protected readonly langOptions = LANG_OPTIONS;

  /** Le bouton est en bas de page : le menu s'ouvre d'abord vers le haut, puis vers le bas s'il manque de place. */
  protected readonly positions: ConnectedPosition[] = [
    { originX: 'start', originY: 'top', overlayX: 'start', overlayY: 'bottom', offsetY: -6 },
    { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top', offsetY: 6 },
  ];
}
